<div
  class="hidden h-16 items-center justify-between bg-white px-6 shadow-sm lg:flex"
>
  <div (click)="closeBooking()" class="w-36 cursor-pointer">
    <img [ngSrc]="logoUrl" alt="logo" height="24" width="139">
  </div>
  <div
    (click)="navigateToCareproviderUnit()"
    class="cursor-pointer text-xl font-medium text-duck-blue-2"
  >
    {{ providerName }}
  </div>
  <div class="flex w-36 justify-end">
    <app-ui-icon-button (click)="closeBooking()" icon="close"></app-ui-icon-button>
  </div>
</div>
